// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".ExportRecord .downLoadUrl {\n  cursor: pointer;\n  font-size: 14px;\n  text-decoration: underline;\n}\n.ExportRecord .downLoadUrl:hover {\n  color: #00bb7c;\n}", ""]);
// Exports
module.exports = exports;
